import * as React from 'react';
import classnames from 'classnames';
import s from './PaymentMethodLogo.scss';
export var CardBrands;
(function (CardBrands) {
    CardBrands["Amex"] = "amex";
    CardBrands["BankTransfer"] = "bankTransfer";
    CardBrands["Boleto"] = "boleto";
    CardBrands["CarteBlue"] = "carteBlue";
    CardBrands["CreditsPrepaidCard"] = "creditsPrepaidCard";
    CardBrands["Diners"] = "diners";
    CardBrands["Discover"] = "discover";
    CardBrands["Elo"] = "elo";
    CardBrands["Jcb"] = "jcb";
    CardBrands["Maestro"] = "maestro";
    CardBrands["Mastercard"] = "mastercard";
    CardBrands["MercadoPagoRecurring"] = "mercadoPagoRecurring";
    CardBrands["MpBanamex"] = "mpBanamex";
    CardBrands["MpBancomer"] = "mpBancomer";
    CardBrands["MpOxxo"] = "mpOxxo";
    CardBrands["Payu"] = "payu";
    CardBrands["MpSerfin"] = "mpSerfin";
    CardBrands["RegDotRu"] = "regDotRu";
    CardBrands["SepaDirectDebit"] = "sepaDirectDebit";
    CardBrands["Solo"] = "solo";
    CardBrands["Unionpay"] = "unionpay";
    CardBrands["Visa"] = "visa";
    CardBrands["Sofort"] = "sofort";
})(CardBrands || (CardBrands = {}));
export var PaymentMethodLogo = function (_a) {
    var cardBrand = _a.cardBrand, _b = _a.className, className = _b === void 0 ? "" : _b;
    return React.createElement("div", { "data-hook": "payment-method-logo", className: classnames(s[cardBrand], className) });
};
//# sourceMappingURL=PaymentMethodLogo.js.map